<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="项目:">
              <el-select v-model="listQuery.ProjectId" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker v-model="listQuery.BeginTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-model="listQuery.EndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 25px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="生成单编号" size="small">
              <el-input v-model="listQuery.OrderNumber" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="原始单编号" size="small">
              <el-input v-model="listQuery.OriginalNumber" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.CustomerService" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>杰小薪设置</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName == '0' ? '原始单' : '生成单' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="expList" :loading="isExping">导出</el-button>
          <el-button type="warning" size="small" @click="uploadHandel">导入</el-button>
          <el-button type="success" size="small" @click="stopHandel('启用')">启用</el-button>
          <el-button type="danger" size="small" @click="stopHandel('停用')">停用</el-button>
          <el-button type="primary" size="small" @click="addProTask">+添加</el-button>
          <el-button type="danger" size="small" @click="delHandel">删除</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <template v-if="activeName == '0'">
            <!-- <el-table-column prop="orderNumber" key="1" label="生成单编号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="originalNumber" key="1.1" label="编号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projectName" key="2" label="项目" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="status" key="3" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="receiveEmail" key="4" label="接收邮箱" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.receiveEmail">
                  <span v-for="(item, index) in row.receiveEmail" :key="index" style="margin-right: 5px;">{{ item.EmailAddress + '; ' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="auto_IMAP_SMTP" key="5" label="是否支持IMAP/SMTP" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="receiving_server" key="6" label="接收服务器地址/端口号" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>

            <el-table-column prop="sending_server" key="7" label="发送服务器地址/端口号" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="sendEmail" key="8" label="发送邮箱" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.sendEmail">
                  <span v-for="(item, index) in row.sendEmail" :key="index" style="margin-right: 5px;">{{ item.EmailAddress + '; ' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="keywords" key="9" label="标题关键词" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="dateRange" key="10" label="操作日期范围" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.dateRange">
                  <span v-for="(item, index) in row.dateRange" :key="index" style="margin-right: 5px;">{{ item.StartTime
                    + '~' + item.endTime + '; ' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="timeRange" key="11" label="操作时间范围" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.timeRange">
                  <span v-for="(item, index) in row.timeRange" :key="index" style="margin-right: 5px;">{{ item.StartTime
                    + ' ~ ' + item.endTime + ';' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="frequency" key="12" label="操作频次" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span>{{ row.frequency ? getFrequencyVal(row.frequency) : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="autoGenerateBill" key="13" label="自动生成结算单" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.autoGenerateBill ? '是' : '否' }} </template>
            </el-table-column>
            <el-table-column prop="bankAccount" key="14" label="对方账户" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="autoTransmitCustomer" key="15" label="自动回传客户" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.autoTransmitCustomer ? '是' : '否' }} </template>
            </el-table-column>
            <el-table-column prop="autoApplySalary" key="16" label="自动申请发薪" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.autoApplySalary ? '是' : '否' }} </template>
            </el-table-column>
            <!-- <el-table-column prop="auto_Salary" key="16" label="自动申请发薪" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.auto_Salary ? '是' : '否' }} </template>
            </el-table-column> -->
            <el-table-column prop="autoApplyInvoice" key="17" label="自动申请开票" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.autoApplyInvoice ? '是' : '否' }} </template>
            </el-table-column>
          </template>
          <template v-if="activeName == '1'">
            <el-table-column prop="orderNumber" key="1" label="编号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projectName" key="2" label="项目" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="status" key="3" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="dateRange" key="4" label="操作日期范围" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.dateRange">
                  <span v-for="(item, index) in row.dateRange" :key="index" style="margin-right: 5px;">{{ item.StartTime
                    + '~' + item.endTime + '; ' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="timeRange" key="5" label="操作时间范围" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div v-if="row.timeRange">
                  <span v-for="(item, index) in row.timeRange" :key="index" style="margin-right: 5px;">{{ item.StartTime
                    + ' ~ ' + item.endTime + ';' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="frequency" key="6" label="操作频次" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span>{{ row.frequency ? getFrequencyVal(row.frequency) : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="autoInsuranceToBeConfirmed" key="7" label="自动参保待确认" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span>{{ row.autoInsuranceToBeConfirmed ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="autoRegisterForEmployment" key="8" label="自动签约登记" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span>{{ row.autoRegisterForEmployment ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="autoSendTextMessage" key="9" label="自动发送签约短信" min-width="130" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span>{{ row.autoSendTextMessage ? '是' : '否' }}</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column label="操作" fixed="right" align="center" width="280">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="timeSetHandel(row)">设置时间频次</el-button>
                <el-button type="text" size="small" @click="flowSetHandel(row)">自动流程设置</el-button>
                <!-- <el-button type="text" size="small" @click="emailSetHandel(row)">邮箱设置</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog title="添加" :visible.sync="addTaskVisible" width="500px" class="res_dialog enter_dialog">
      <el-form ref="addTaskForm" :model="addTaskForm" class="" label-width="100px" size="small">
        <el-form-item label="项目:" prop="type">
          <el-select v-model="taskProject" placeholder="" style="width:300px" filterable @change="changeObj" value-key="Projectid">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTaskVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddTask" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="uploadVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="uploadRules" ref="addTaskForm" :model="addTaskForm" class="" label-width="100px" size="small">
        <el-form-item label="导入Excel" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 自动流程设置 -->
    <el-dialog title="自动流程设置" :visible.sync="flowSetVisible" width="550px" class="res_dialog enter_dialog">
      <el-form ref="flowForm" :model="flowForm" class="flowForm" label-width="140px" size="small">
        <el-form-item label="项目:" prop="type">
          {{ projectName }}
        </el-form-item>
        <el-form-item label="自动生成税后工资单">
          <el-radio-group v-model="flowForm.isAutoAfterTaxPayroll">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="flowForm.isAutoAfterTaxToCustomer">自动回传客户</el-checkbox>
        </el-form-item>
        <el-form-item label="自动生成税前工资单">
          <el-radio-group v-model="flowForm.isAutoPreTaxPayroll">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="flowForm.isAutoPreTaxToCustomer">自动回传客户</el-checkbox>
        </el-form-item>
        <el-form-item label="自动生成对账单">
          <el-radio-group v-model="flowForm.isAutoStateAccount">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="flowForm.isAutoStateAccountToCustomer">自动回传客户</el-checkbox>
        </el-form-item>
        <el-form-item label="自动生成结算单:">
          <el-radio-group v-model="flowForm.auto_generate_bill">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="flowForm.auto_transmit_customer">自动回传客户</el-checkbox>
        </el-form-item>
        <el-form-item label="字典模板:">
          <el-select v-model="flowForm.templateId" placeholder="" style="width:300px" filterable>
            <el-option v-for="item in modelList" :key="item.Id" :label="item.key" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="自动回传客户:">
          <el-radio-group v-model="flowForm.auto_transmit_customer">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="自动申请发薪:">
          <el-radio-group v-model="flowForm.auto_apply_salary">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="算薪自动提交发放:" v-if="flowForm.auto_apply_salary">
          <el-radio-group v-model="flowForm.auto_Salary">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动申请开票:">
          <el-radio-group v-model="flowForm.auto_apply_invoice">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="支持IMAP/SMTP:">
          <el-radio-group v-model="flowForm.auto_IMAP_SMTP">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动流程配置人:">
          <el-select v-model="flowForm.notifier" placeholder="" style="width:300px" filterable>
            <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item.Username"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收服务器:">
          <el-input v-model="receiving_server" type="textarea" :autosize="{ minRows: 2 }" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="发送服务器:">
          <el-input v-model="sending_server" type="textarea" :autosize="{ minRows: 2 }" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flowSetVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetFlow" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 设置时间频次 -->
    <el-dialog title="设置时间频次" :visible.sync="frequencyVisible" width="750px" class="res_dialog enter_dialog">
      <el-form ref="frequencyForm" :model="frequencyForm" class="" v-if="frequencyVisible" label-width="100px" size="small">
        <el-form-item label="频次:" size="small">
          <div class="flex">
            每
            <el-input v-model="frequencyForm.frequency.间隔" size="small" style="width:60px;margin:0 5px;" type="number"></el-input>
            <el-select v-model="frequencyForm.frequency.单位" size="small" placeholder="" style="width: 80px;margin:0 5px">
              <el-option value="分"></el-option>
              <el-option value="小时"></el-option>
              <el-option value="天"></el-option>
              <el-option value="周"></el-option>
            </el-select>
            1次
          </div>
        </el-form-item>
        <el-form-item label="起止日期:" size="small">
          <div class="flex">
            <el-select v-model="addForm.timeType" placeholder="" style="width:80px;margin-left: 10px;">
              <el-option value="每周"></el-option>
              <el-option value="每月"></el-option>
              <el-option value="每季度"></el-option>
              <el-option value="每年"></el-option>
            </el-select>
            <el-select v-model="addForm.start" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
            </el-select>
            <span style="margin-left: 10px;"> ~ </span>
            <el-select v-model="addForm.end" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
              <el-option value="月末" v-if="addForm.timeType == '每月'"></el-option>
            </el-select>
            <el-time-picker v-model="addForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <span style="margin-left: 10px;"> ~ </span>
            <el-time-picker v-model="addForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <div class="blueName cp" @click="addTimeSet()" style="margin-left: 20px;">+添加</div>
          </div>
          <div v-for="(item, index) in frequencyForm.date_range" :key="index" class="flex" style="padding-left: 30px;">
            <span>{{ item.StartTime }} ~ {{ item.endTime }} </span>
            <span style="margin-left: 10px;" v-if="frequencyForm.time_range[index] != undefined">{{
              frequencyForm.time_range[index].StartTime }} ~ {{ frequencyForm.time_range[index].endTime }}</span>
            <span class="blueName cp" style="margin-left: 20px;" @click="delTimeSet(index)">删除</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="frequencyVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetFrequency" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改邮箱" :visible.sync="showEmailSet" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="emailForm" :model="emailForm" class="" label-width="100px" size="small">
        <el-form-item label="接受邮箱">
          <el-input v-model="receiveEmail" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="发送邮箱">
          <el-input v-model="sendEmail" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="emailForm.password" size="small" style="width:300px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEmailSet = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEmailSet" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "status",
              order: 0
            }]
          },
          ProjectId: '',
          BeginTime: '',
          EndTime: '',
          OrderNumber: '', //生成单编号
          OriginalNumber: '', //原始单编号
          DepartmentId: '',
          CustomerService: '',
          taskType: 10
          // userId: Cookies.get("userid-b"),
          // roleType: localStorage.loginRoletype,
        },
        receiveEmail: '', //接受邮箱
        sendEmail: '', //发送邮箱
        receiving_server: '',
        sending_server: '',
        addTaskForm: {
          projectId: '',
          projectName: '',
          status: '启用',
          TaskType: 10, //10结算单任务设置 20杰小职设置 30杰小金设置
        },
        taskProject: '',
        isExping: false,
        fileList: [],
        uploadVisible: false,
        showDropScreen: -1,
        activeName: '0',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        uploadRules: {},
        addTaskVisible: false,
        isbtnLoading: false,
        uploadForm: {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        flowSetVisible: false,
        userList: [], //用户列表
        projectName: '',
        flowForm: {
          Id: '',
          status: '启用',
          auto_generate_bill: '', //自动生成结算单
          auto_transmit_customer: '', //自动回传客户
          auto_apply_salary: '', //自动申请发薪
          auto_Salary: '',
          auto_apply_invoice: '', //自动申请开票
          auto_IMAP_SMTP: '', //支持IMAP/SMTP
          receiving_server: '', //接收服务器
          sending_server: '', //发送服务器
          notifier: '', //自动流程配置人
        },
        frequencyVisible: false,
        frequencyForm: {
          frequency: {
            间隔: '',
            单位: '',
            显示文本: '',
          },
          date_range: [],
          time_range: [],
          id: ''
        },
        addForm: {
          timeType: '',
          start: '',
          end: '',
          startTime: '',
          endTime: ''
        },
        showEmailSet: false,
        emailForm: {
          id: '',
          receiveEmail: '',
          sendEmail: '',
          password: ''
        },
        rules: {},
        modelList: [],
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.changeTab()
      } else {
        this.getList();
      }
      this.getProList();
      this.getModelList();
      this.getUserList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      getUserList() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        };
        xz.getauthUserInfoByorgancode(dataPage).then((res) => {
          if (res && res.totalcount > 0) {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.GetTaskSettings();
      },
      GetTaskSettings() {
        this.loading = true;
        xz.RPAFun(this.listQuery, 'GetTaskSettings').then(res => {
          if (res.status === 'ok') {
            console.log(this.tableData);
            if (res.data.data.length > 0) {
              res.data.data.forEach(e => {
                e.dateRange = this.safeParseJson(e.dateRange, []);
                e.timeRange = this.safeParseJson(e.timeRange, []);
                e.receiveEmail = this.safeParseJson(e.receiveEmail, []);
                e.sendEmail = this.safeParseJson(e.sendEmail, []);
                e.receivingServer = this.safeParseJson(e.receivingServer, []);
                e.sendingServer = this.safeParseJson(e.sendingServer, []);
              });
            }
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      safeParseJson(str, defaultValue) {
        try {
          return str ? JSON.parse(str) : defaultValue;
        } catch (e) {
          console.warn('Failed to parse JSON string:', str, 'Error:', e);
          return defaultValue;
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab) {
        if (this.activeName == '0') {
          this.listQuery.taskType = 10;
          this.addTaskForm.taskType = 10;
          this.getList();
        } else if (this.activeName == '1') {
          this.$router.push({
            path: '/jobTask'
          })
        } else if (this.activeName == '2') {
          this.$router.push({
            path: '/bankSet'
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      uploadHandel() {
        this.uploadForm.fileUrl = '';
        this.fileList = [];
        this.isbtnLoading = false;
        this.uploadVisible = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.uploadForm.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.uploadForm.fileUrl = res;
          } else {
            this.uploadForm.fileUrl = ''
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20241223104534570.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入拆分模版.xlsx";
        aTag.click();
      },
      confirmUpload() {
        if (this.uploadForm.fileUrl) {
          this.isbtnLoading = true;
          xz.RPAFun(this.uploadForm, 'ImportStatementTaskSettings').then(res => {
            if (res.status == 'ok') {
              this.isbtnLoading = false;
              this.getList();
              this.uploadVisible = false;
              this.$message.success("导入成功！");
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      addProTask() {
        this.addTaskForm = {
          projectId: '',
          projectName: '',
          status: '启用',
          TaskType: 10
        }
        this.taskProject = '';
        this.isbtnLoading = false;
        this.addTaskVisible = true;
      },
      changeObj(val) {
        this.addTaskForm.projectId = val.Projectid;
        this.addTaskForm.projectName = val.StrprojectName;
      },
      confirmAddTask() {
        if (this.addTaskForm.projectId) {
          this.isbtnLoading = true;
          xz.RPAFun(this.addTaskForm, 'CreateOrEditStatementTaskSettings').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.addTaskVisible = false;
              this.isbtnLoading = false;
              this.$message.success('添加成功！')
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请选择项目')
        }
      },
      stopHandel(status) {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr,
                Status: status
              }
              xz.RPAFun(d, 'EnableTaskStatement').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('操作成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      delHandel() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr
              }
              xz.RPAdel(d, 'DeleteTaskSetting').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('删除成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      expList() {
        this.isExping = true;
        xz.exportRPA(this.listQuery, 'ExportTaskSettings').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "任务结算单设置导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      emailSetHandel(row) {
        this.receiveEmail = row.receiveEmail.length > 0 ? row.receiveEmail[0].EmailAddress : '';
        this.sendEmail = row.sendEmail.length > 0 ? row.sendEmail[0].EmailAddress : '';
        this.emailForm = {
          id: row.id,
          receiveEmail: row.receiveEmail,
          sendEmail: row.sendEmail,
          password: row.password
        }
        this.showEmailSet = true;
      },
      confirmEmailSet() {
        if (this.emailForm.receiveEmail.length > 0) {
          this.emailForm.receiveEmail[0].EmailAddress = this.receiveEmail;
          this.emailForm.receiveEmail = JSON.stringify(this.emailForm.receiveEmail)
        } else {
          this.emailForm.receiveEmail = [{
            EmailAddress: this.receiveEmail,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
          this.emailForm.receiveEmail = JSON.stringify(this.emailForm.receiveEmail)
        }
        if (this.emailForm.sendEmail.length > 0) {
          this.emailForm.sendEmail[0].EmailAddress = this.sendEmail;
          this.emailForm.sendEmail = JSON.stringify(this.emailForm.sendEmail)
        } else {
          this.emailForm.sendEmail = [{
            EmailAddress: this.sendEmail,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
        }
        this.isbtnLoading = true;
        xz.RPAFun(this.emailForm, 'SetEmail').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.showEmailSet = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      flowSetHandel(row) {
        this.receiving_server = row.receivingServer.length > 0 ? row.receivingServer[0].EmailAddress : '';
        this.sending_server = row.sendingServer.length > 0 ? row.sendingServer[0].EmailAddress : '';
        this.projectName = row.projectName;
        this.flowForm = {
          Id: row.id,
          status: row.status,
          auto_generate_bill: row.autoGenerateBill, //自动生成结算单
          auto_transmit_customer: row.autoTransmitCustomer, //自动回传客户
          auto_apply_salary: row.autoApplySalary, //自动申请发薪
          auto_Salary: row.auto_Salary,
          auto_apply_invoice: row.autoApplyInvoice, //自动申请开票
          auto_IMAP_SMTP: row.autoImapSmtp, //支持IMAP/SMTP
          receiving_server: row.receivingServer, //接收服务器
          sending_server: row.sendingServer, //发送服务器
          templateId: row.templateId,
          isAutoAfterTaxPayroll: row.isAutoAfterTaxPayroll,
          isAutoAfterTaxToCustomer: row.isAutoAfterTaxToCustomer,
          isAutoPreTaxPayroll: row.isAutoPreTaxPayroll,
          isAutoPreTaxToCustomer: row.isAutoPreTaxToCustomer,
          isAutoStateAccount: row.isAutoStateAccount,
          isAutoStateAccountToCustomer: row.isAutoStateAccountToCustomer,
          notifier: row.notifier, //自动流程配置人
        }
        this.isbtnLoading = false;
        this.flowSetVisible = true;
      },
      //获取模板列表
      getModelList() {
        let d = {
          PageModel: {
            Rows: 1000,
            Page: 1,
            OrderInput: []
          },
          BusiId: '字典库模板',
          key: '',
        }
        xz.RPAFun(d, 'GetFieldMatchingList').then(res => {
          if (res.status == 'ok') {
            this.modelList = res.data.data;
            this.modelList.forEach(e => {
              if (e.value == '是') {
                this.flowForm.templateId = e.templateId
              }
            });
          } else {
            this.modelList = [];
          }
        })
      },
      confirmSetFlow() {
        if (this.flowForm.receiving_server.length > 0) {
          this.flowForm.receiving_server[0].EmailAddress = this.receiving_server;
          this.flowForm.receiving_server = JSON.stringify(this.flowForm.receiving_server)
        } else {
          this.flowForm.receiving_server = [{
            EmailAddress: this.receiving_server,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
          this.flowForm.receiving_server = JSON.stringify(this.flowForm.receiving_server)
        }
        if (this.flowForm.sending_server.length > 0) {
          this.flowForm.sending_server[0].EmailAddress = this.sending_server;
          this.flowForm.sending_server = JSON.stringify(this.flowForm.sending_server)
        } else {
          this.flowForm.sending_server = [{
            EmailAddress: this.sending_server,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
          this.flowForm.sending_server = JSON.stringify(this.flowForm.sending_server)
        }
        this.isbtnLoading = true;
        xz.RPAFun(this.flowForm, 'SetWorkerFlow').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.flowSetVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      timeSetHandel(row) {
        let frequency = {
          间隔: '',
          单位: '',
          显示文本: '',
        };
        if (row.frequency) {
          frequency = JSON.parse(row.frequency)
        }
        this.frequencyForm = {
          frequency: frequency,
          status: row.status,
          date_range: row.dateRange ? eval(row.dateRange) : [],
          time_range: row.timeRange ? eval(row.timeRange) : [],
          id: row.id
        }
        this.isbtnLoading = false;
        this.frequencyVisible = true;
        console.log(this.frequencyForm)
      },
      addTimeSet() {
        if (this.addForm.timeType && this.addForm.start && this.addForm.end && this.addForm.startTime && this.addForm.endTime) {
          let date = {
            StartTime: this.addForm.timeType + this.addForm.start,
            endTime: this.addForm.timeType + this.addForm.end,
          }
          let time = {
            StartTime: this.addForm.startTime,
            endTime: this.addForm.endTime
            // 时间: `${this.addForm.startTime} ~ ${this.addForm.endTime}`
          }
          this.frequencyForm.date_range.push(date)
          this.frequencyForm.time_range.push(time)
          this.addForm = {
            timeType: '',
            start: '',
            end: '',
            startTime: '',
            endTime: ''
          }
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      delTimeSet(i) {
        this.frequencyForm.date_range.splice(i, 1)
        this.frequencyForm.time_range.splice(i, 1)
      },
      confirmSetFrequency() {
        if (this.addForm.timeType) {
          this.addTimeSet();
        }
        if (this.frequencyForm.date_range.length > 0 && this.frequencyForm.time_range.length > 0) {
          this.isbtnLoading = true;
          this.frequencyForm.frequency.显示文本 = `每${this.frequencyForm.frequency.间隔}${this.frequencyForm.frequency.单位}1次`
          let d = JSON.parse(JSON.stringify(this.frequencyForm));
          d.frequency = JSON.stringify(d.frequency);
          d.date_range = JSON.stringify(d.date_range);
          d.time_range = JSON.stringify(d.time_range);
          xz.RPAFun(d, 'SetDateTime').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isbtnLoading = false;
              this.$message.success('保存成功');
              this.frequencyVisible = false;
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      getFrequencyVal(val) {
        let v = JSON.parse(val);
        try {
          return v.显示文本
        } catch {
          return ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .flowForm .el-form-item {
    margin-bottom: 5px;
  }
</style>